"use client";

import AudioWave from "@/components/AudioWave";
import Image from "next/image";
import { trackEvent } from "@/lib/analytics";

export default function HeroSection() {
  return (
    <section className="bg-white md:bg-[#F9F9F6] text-black relative overflow-hidden min-h-screen md:h-[calc(100vh-4rem)]">
      <div className="flex flex-col w-full h-full justify-between relative z-10">
        {/* Main content area with primary elements */}
        <div className="flex-1 flex flex-col items-center justify-center px-4 z-10 py-8 md:py-0 mt-20 md:mt-12">
          {/* a16z speedrun badge */}
          <div className="space-y-2 mb-1">
            <div className="inline-flex items-center gap-1 pl-1">
              <span className="text-base font-semibold text-primary-color">
                backed by
              </span>
              <Image
                src="/a16z-watermark.svg"
                alt="a16z speedrun"
                width={150}
                height={30}
                className="h-28 w-45"
                priority
              />
            </div>
          </div>

          <h1 className="text-[2.6rem] sm:text-5xl md:text-6xl lg:text-6xl font-bold mb-6 text-center text-primary-color leading-[1.08]">
            Healthcare engagement that
            <br />
            <span className="italic text-coverage-alert">reaches every member.</span>
          </h1>

          <p className="max-w-3xl text-center text-base sm:text-lg md:text-xl leading-relaxed text-primary-color">
            Members ignore email, phone calls, and app notifications. Logical
            Health meets members where they are, turning outreach into
            conversations that find and resolve the real barriers to action.
          </p>

          <div className="flex justify-center mt-8">
            <div className="flex flex-col sm:flex-row gap-4 items-center w-full max-w-lg mx-auto">
              <a
                href="https://calendly.com/lauren-logical/logical-health-intro-call"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("cta_click", { cta: "book_a_demo_hero" })}
                className="w-full sm:w-48 bg-coverage-alert hover:bg-[#9C3F1C] text-white text-center px-6 py-3 rounded-full font-semibold text-base transition-all hover:shadow-xl hover:scale-105"
              >
                Book a Demo
              </a>
            </div>
          </div>
        </div>

        {/* Footer with wave and partners */}
        <div className="w-full mt-6 md:mt-0">
          {/* Audio Wave Animation */}
          <div className="w-full relative">
            <AudioWave />
          </div>
        </div>
      </div>
    </section>
  );
}
